import React, { useState } from 'react';
import { Button, Card, Form, Input } from 'antd';
import { withRouter } from 'react-router-dom';
import './styles.css';
import { globalForgotPasswordAPI } from '../../../utils/apis';

const { Item, useForm } = Form;
const LOGIN_PAGE = '/login';
const SUCCESS_MESSAGE = 'Email was sent successfully.\nPlease check your inbox';

const ForgotPasswordForm = ({ history, popUpNotification }) => {
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setIsLoading(true);
      await globalForgotPasswordAPI.doPost(values);
      popUpNotification('success', {
        title: 'Done!',
        description: SUCCESS_MESSAGE,
      });
      setIsLoading(false); // needed at the end so notification are not displayed twice
    } catch (error) {
      let notificationMessage;
      if (error.message.includes('Bad request')) {
        notificationMessage = 'Email is not valid';
      } else if (
        error.message.includes('Cannot send restore password to email provided')
      ) {
        notificationMessage =
          'Cannot send update link for this email. Please contact support';
      } else {
        notificationMessage = 'Something went wrong. Please try again later';
      }
      popUpNotification('error', {
        title: 'Sorry!',
        description: notificationMessage,
      });
      setIsLoading(false); // needed at the end so notification are not displayed twice
    }
  };

  return (
    <Card className={'forgot-password-card'}>
      <Form
        form={form}
        layout="vertical"
        style={{ display: 'flex', flexDirection: 'column' }}
        onFinish={onFinish}
        aria-label="login-form"
      >
        <Item
          name="email"
          label="Email"
          required
          rules={[
            {
              type: 'email',
              message: 'Invalid email address',
            },
            { required: true },
          ]}
        >
          <Input />
        </Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Send email
        </Button>
        <Button
          className={'btn-link'}
          type="link"
          onClick={() => history.push(LOGIN_PAGE)}
        >
          Sign in
        </Button>
      </Form>
    </Card>
  );
};

export default withRouter(ForgotPasswordForm);
